import { Action, State, StateContext } from "@ngxs/store";
import { CommunityRights } from "./community-rights.actions";
import { Injectable } from "@angular/core";
import { BaseStateModel } from "../base/model/base-state.model";
import { ResetStateDefaults } from "../base-action-class.model";

class CommunityRightsModel extends BaseStateModel<CommunityRightsModel> {

  //region FIELDS
  //all the community Ids (future)
  communityIds: Set<number> = new Set<number>();
  //current definition - state of development
  communityId: number;

  //ids (=orgId) of all members of the community
  communityOrgIds: Set<number> = new Set<number>();

  //community privileges
  communityPrivileges: Set<number> = new Set<number>();
  //endregion

}

const getDefaults = (): CommunityRightsModel => ({
  communityIds: new Set<number>(),
  communityId: null,
  communityOrgIds: new Set<number>(),
  communityPrivileges: new Set<number>()
});

@State<CommunityRightsModel>({
  name:   'communityRights',
  defaults: getDefaults()
})
@Injectable()
export class CommunityRightsXsState {

  @Action(CommunityRights.SetPrivileges)
  public setPrivileges(ctx: StateContext<CommunityRightsModel>, action: CommunityRights.SetPrivileges) {
    //if logic is knwon, implement it
  }

  @Action(CommunityRights.SetCommunity)
  public setCommunity(ctx: StateContext<CommunityRightsModel>, action: CommunityRights.SetCommunity) {
    //if logic is knwon, implement it
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<CommunityRightsModel>): void {
    ctx.setState({...getDefaults()});
  }

}
